import React from 'react';
import * as Images from '../../assets';
import { Grid } from '@mui/material';
import { LightBlueButton } from '../../components';
import { routesName } from '../../constants/routes-name';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const HowItWorks = () => {
  const { user } = useSelector(({ user }) => user);

  return (
    <div
      id="Howitworks"
      style={{
        backgroundImage: `url('${Images.homePage1}')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundColor: '',
        transition:
          'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
      }}
    >
      <div className="bg-[#ffffffad]">
        <div
          className="h-full flex flex-col items-center space-y-8 py-36 px-8"
          /* style={{
            backgroundColor: 'transparent',
            backgroundImage:
              'radial-gradient(at center center, #8a8c8f80 23%, #d7cccc7070%)',
            transition: 'background 0.3s, border-radius 0.3s, opacity 0.3s',
          }} */
        >
          <div className="text-5xl font-bold">How it works</div>
          <div className="md:w-2/3 w-full text-center">
            Our experienced team source and receive business opportunities from
            the leading international humanitarian organisations and we give you
            the tools you need to discover new opportunities.{' '}
          </div>
          <div className="pt-8">
            <Grid container spacing={2} className="flex justify-center">
              <Grid item xs={12}>
                <Grid
                  container
                  spacing={{ lg: 1, xs: 2 }}
                  className="flex justify-center"
                >
                  <Grid
                    className="flex flex-col items-center"
                    item
                    lg={2.3}
                    md={4}
                    xs={12}
                  >
                    <div className="w-full h-full bg-white rounded py-16 px-3 flex flex-col items-center gap-6 shadow-md border border-grey-300">
                      <img
                        style={{ height: '50px', width: '50px' }}
                        src={Images.writeing}
                      />
                      <div className="text-xl font-bold text-center">
                        Easy Registration
                      </div>
                      <div className="text-sm text-center leading-[2]">
                        Our quick and easy registration enables you to get
                        started and view all public and active tender notices in
                        a few steps
                      </div>
                    </div>
                  </Grid>

                  <Grid
                    className="flex flex-col items-center"
                    item
                    lg={2.3}
                    md={4}
                    xs={12}
                  >
                    <div className="w-full h-full bg-white rounded py-16 px-3 flex flex-col items-center gap-6 shadow-md border border-grey-300">
                      <img
                        style={{ height: '50px', width: '50px' }}
                        src={Images.tenders}
                      />
                      <div className="text-xl font-bold text-center">
                        View Tenders
                      </div>
                      <div className="text-sm text-center leading-[2]">
                        100% cloud-based with FREE access to view business
                        opportunities effortlessly in the humanitarian sector
                        and gain immediate access to tender information and
                        relevant documents.
                      </div>
                    </div>
                  </Grid>

                  <Grid
                    className="flex flex-col items-center"
                    item
                    lg={2.3}
                    md={4}
                    xs={12}
                  >
                    <div className="w-full h-full bg-white rounded py-16 px-3 flex flex-col items-center gap-6 shadow-md border border-grey-300">
                      <img
                        style={{ height: '50px', width: '50px' }}
                        src={Images.bell}
                      />
                      <div className="text-xl font-bold text-center">
                        Email Alerts
                      </div>
                      <div className="text-sm text-center leading-[2]">
                        Receive daily email alerts customised by you, with
                        relevant business opportunities straight to your inbox
                        ensuring you don’t miss important deadlines or
                        opportunities.
                      </div>
                    </div>
                  </Grid>

                  <Grid
                    className="flex flex-col items-center"
                    item
                    lg={2.3}
                    md={4}
                    xs={12}
                  >
                    <div className="w-full h-full bg-white rounded py-16 px-3 flex flex-col items-center gap-6 shadow-md border border-grey-300">
                      <img
                        style={{ height: '50px', width: '50px' }}
                        src={Images.search}
                      />
                      <div className="text-xl font-bold text-center">
                        Advanced Search
                      </div>
                      <div className="text-sm text-center leading-[2]">
                        Get advanced search with your Alert Service, allowing
                        you to filter by gods/services categories, geographical
                        locations and contracting organisation. Save your
                        complex searches to MyTenders, allowing you to easily
                        revisit and start working on the business opportunities.
                      </div>
                    </div>
                  </Grid>

                  <Grid
                    className="flex flex-col items-center"
                    item
                    lg={2.3}
                    md={4}
                    xs={12}
                  >
                    <div className="w-full h-full bg-white rounded py-16 px-3 flex flex-col items-center gap-6 shadow-md border border-grey-300">
                      <img
                        style={{ height: '50px', width: '50px' }}
                        src={Images.tenders}
                      />
                      <div className="text-xl font-bold text-center">
                        Multiple Alert Recipients
                      </div>
                      <div className="text-sm text-center leading-[2]">
                        Unlock the full potential of your Alert Service
                        subscription by adding your colleagues at no extra
                        charge. Everyone in your team receive the same alert
                        daily and all are kept in the loop effortlessly.
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
          <div className="flex justify-center pt-12">
            {!user && (
              <Link to={routesName.pricing}>
                <LightBlueButton /* sx={{ py: 1.2}} */ size="large">
                  Join Aid-LINK
                </LightBlueButton>
              </Link>
            )}
            {user && (
              <Link to={routesName.pricing}>
                <LightBlueButton size="large">Go to dashboard</LightBlueButton>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
